import { render, staticRenderFns } from "./PaymentSuccessPage.vue?vue&type=template&id=be1fda84&scoped=true"
import script from "./PaymentSuccessPage.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessPage.vue?vue&type=script&lang=js"
import style0 from "./PaymentSuccessPage.vue?vue&type=style&index=0&id=be1fda84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1fda84",
  null
  
)

export default component.exports